import angular from 'angular';
import easypiechart from 'easy-pie-chart/dist/angular.easypiechart';

export default angular.module('cms.panels.pie-chart', ['easypiechart'])
    .component('cmsPieChart', {
        bindings: {
            title: '@',
            icon: '@',
            percent: '@',
            description: '@'
        },
        template: require('./pieChart.html'),
        controller: function () {
            this.options = {
                easing: 'easeOutBounce',
                barColor:'#2C3E50',
                trackColor: 'rgba(0,0,0,0)',
                size: 84,
                scaleLength: 0,
                animation: 2000,
                lineWidth: 9,
                lineCap: 'round'
            };
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Chart/PieChart/pieChart.js